require("./main.css");

var angular = require("angular");
var amt_admin = require("amt_admin").default;
var app = angular.module("ww2_analytics.life_time", [amt_admin]);
var { provider_states_by_gameplay } = require('amt_admin/utils.js');

app.service("life_time_api", [
  "jsonrpc",
  function (jsonrpc) {
    var service = jsonrpc.newService("life_time");
    this.by_day = service.createMethod("by_day");
    this.by_month = service.createMethod("by_month");
    this.by_mission = service.createMethod("by_mission");
    this.benchmark = service.createMethod("benchmark");
    this.start_ltvprediction_task = service.createMethod('start_ltvprediction_task');
    this.get_players_purchases_by_create_date = service.createMethod(
      "get_players_purchases_by_create_date"
    );
  }
]);

var players_purchases_tpl = require("./players_purchases.html");
var dau_by_ltv_tpl = require("./dau_by_ltv.html");
var mau_by_arppu_tpl = require("./mau_by_arppu.html");
var dau_to_ltv_tpl = require("./dau_to_ltv.html");
var dau_wau_mau_tpl = require("./dau_wau_mau/view.html");


app.config([
  "$stateProvider",
  function ($stateProvider) {
    provider_states_by_gameplay($stateProvider, {
        adult_idler: [
          'amt.ww2.life_time.by_day',
          'amt.ww2.life_time.dau_by_ltv',
        ],
      })
      .state("amt.ww2.life_time", {
        url: "/life_time",
        template: "<div ui-view></div>",
        reloadOnSearch: false,
        abstract: true,
        data: {
          priority: 900,
          title: "Life Time",
          role: "life_time"
        },
        menu: {
          glyphicon: "ok",
          childs: [
            {state: "amt.ww2.life_time.by_day", glyphicon: "ok"},
            {state: "amt.ww2.life_time.by_month", glyphicon: "ok"},
            {state: "amt.ww2.life_time.by_mission", glyphicon: "ok"},
            {state: "amt.ww2.life_time.benchmark", glyphicon: "ok"},
            {state: "amt.ww2.life_time.prediction", glyphicon: "ok"},
            {state: "amt.ww2.life_time.dau_by_ltv", glyphicon: "ok"},
            {state: "amt.ww2.life_time.mau_by_arppu", glyphicon: "ok"},
            {state: "amt.ww2.life_time.dau_to_ltv", glyphicon: "ok"},
            {state: "amt.ww2.life_time.dau_wau_mau", glyphicon: "ok"},
          ]
        }
      })
      .state("amt.ww2.life_time.by_mission", require("./by_mission").default)
      .state("amt.ww2.life_time.by_day", require('./by_day').default)
      .state("amt.ww2.life_time.by_month", require('./by_month').default)
      .state("amt.ww2.life_time.players_purchases", {
        url: "/players_purchases/:date",
        reloadOnSearch: false,
        template: players_purchases_tpl,
        data: {
          title: "Player Purchases"
        },
        resolve: {
          data: [
            "life_time_api",
            "$stateParams",
            "chartFilters",
            function (life_time_api, $stateParams, chartFilters) {
              return life_time_api.get_players_purchases_by_create_date({
                filters: chartFilters.get_chart_filters().filters,
                date: $stateParams.date
              });
            }
          ]
        },
        controller: [
          "$scope",
          "data",
          "chartFilters",
          "$stateParams",
          "life_time_api",
          function ($scope, data, chartFilters, $stateParams, life_time_api) {
            $scope.data = data;
            $scope.total = data.reduce(function (total, item) {
              return total + item.price;
            }, 0);

            chartFilters.onChangeChartParams(
              "update_players_purchases",
              function (model) {
                life_time_api
                  .get_players_purchases_by_create_date({
                    filters: model.filters,
                    date: $stateParams.date
                  })
                  .then(function (resp) {
                    $scope.data = resp;
                    $scope.total = $scope.data.reduce(function (total, item) {
                      return total + item.price;
                    }, 0);
                  });
              }
            );
          }
        ]
      })
      .state("amt.ww2.life_time.benchmark", require('./benchmark').default)
      .state("amt.ww2.life_time.prediction", require('./prediction').default)
      .state("amt.ww2.life_time.dau_by_ltv", {
        url: "/dau_by_ltv",
        template: dau_by_ltv_tpl,
        reloadOnSearch: false,
        data: {
          priority: 800,
          title: "DAU by LTV"
        }
      })
      .state("amt.ww2.life_time.mau_by_arppu", {
        url: "/mau_by_arppu",
        template: mau_by_arppu_tpl,
        reloadOnSearch: false,
        data: {
          priority: 800,
          title: "MAU by ARPPU"
        }
      })
    .state("amt.ww2.life_time.dau_to_ltv", {
        url: "/dau_to_ltv",
        template: dau_to_ltv_tpl,
        reloadOnSearch: false,
        data: {
          priority: 800,
          title: "DAULTV"
        }
      })
    .state("amt.ww2.life_time.dau_wau_mau", {
        url: "/dau_wau_mau",
        template: dau_wau_mau_tpl,
        reloadOnSearch: false,
        data: {
          priority: 800,
          title: "DAU/MAU/WAU"
        }
      })
  }
]);

export default app.name;
